import { render } from "./DroppablePage.vue?vue&type=template&id=d8d515bc&scoped=true"
import script from "./DroppablePage.vue?vue&type=script&lang=js"
export * from "./DroppablePage.vue?vue&type=script&lang=js"

import "./DroppablePage.vue?vue&type=style&index=0&id=d8d515bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d515bc"]])

export default __exports__